export default __webpack_public_path__ + "static/media/img007.87d6607c.png";